'use strict'

/**
 * Module qui gère l'affichage des alertes pour la page catalogue et produit
 */

import ajaxLoader from 'Modules/ajaxLoader'
import cleanTextOnFocus from 'Modules/cleanTextOnFocus'
import validationForm from 'Modules/validationForm'
import url from 'Modules/url'

// Var pour l'alerte de la page catalogue
const J_SHOW_ALERTE_CONFIRMATION = '.j_show_alerte_confirmation'
const J_SHOW_ALERTE_CONFIRMATION_MOB = '.j_show_alerte_confirmation_btnmob'
const J_CATALOGUE_ALERT_CONTENT_DESTINATION =
    '.j_catalogue_alerte_destination_showAlerte'
const J_CATALOGUE_ALERT_POPUP = '.j_catalogueAlertePopup_showAlerte'
const J_EMAIL = '.j_email_showAlerteConfirmation'

// Var de l'alerte de la page produit
const J_SELECT_ALERTE_PRODUIT = '.j_alerte_showAlerte'
const J_TAILLE_INDISPO = 'j_tIndispo_showAlerte'
const J_PRODUIT_ALERT_POPUP = '.j_produitAlertePopup_showAlerte'
const J_PRODUIT_ALERTE_CONTENT_DESTINATION =
    '.j_produit_alerte_destination_showAlerte'
const J_ACTION_DATA = 'action'
const J_REFERENCE_MODEL = '.j_rm_showAlerte'
const J_CODE_COULEUR = '.j_cc_showAlerte'

const J_SUBMIT_ALERT_BUTTON = '.j_submit_showAlert'
const J_LIBELLE_DATA = 'libelle'
const J_FORM = '.j_form_showAlerte'
const J_RESULT_LOCATION = '.j_result_showAlert'
const J_EMAIL_PRODUCT = '.j_emailAlert'

/*
 * Set l'event sur le module alerte en bas du listing des produits de la page catalogue
 */
function setEventCatalogue() {
    const action = $(J_SHOW_ALERTE_CONFIRMATION).data('action') // On récupère le controller visé
    $(J_SHOW_ALERTE_CONFIRMATION).off()
    $(J_SHOW_ALERTE_CONFIRMATION).on('click', function (event) {
        const params = url.getAllParameters()
        const email = $(event.currentTarget).prev().val()
        // On récupère l'email et vérifie s'il est valide. sinon on met l'erreur dans l'input
        if (!validationForm.isValideEmail(email)) {
            $(event.currentTarget).prev()[0].value = $t('INVALIDEMAIL')
            return
        } else {
            params.emailAlert = email
        }
        ajaxLoader.loadAndExecuteCallBack(
            'POST',
            params,
            function (content) {
                if (content.indexOf('window.location.href') == -1) {
                    $(J_CATALOGUE_ALERT_CONTENT_DESTINATION)
                        .empty()
                        .append(content)
                    $(J_CATALOGUE_ALERT_POPUP).modal({
                        keyboard: true,
                        show: true
                    })
                }
            },
            function (content) {
                const $location = $(J_CATALOGUE_ALERT_CONTENT_DESTINATION)
                $location.empty().append($t('AJAXLOADERINTERNALERROR'))
                $(J_CATALOGUE_ALERT_POPUP).modal({
                    keyboard: true,
                    show: true
                })
            },
            action
        )
    })
}

/*
 * Set l'event sur la lsite des tailles de la page produit
 * la popup d'alerte s'affichera si c'est une taille indispo.
 */
function setEventProduit() {
    $(J_SELECT_ALERTE_PRODUIT).on('change', function (event) {
        if (
            $('option:selected', event.currentTarget).hasClass(J_TAILLE_INDISPO)
        ) {
            // Si la taille sélectionné est indispo (elle contiendra J_TAILLE_INDISPO en class css) on affiche la popup
            const action = $(event.currentTarget).data(J_ACTION_DATA)
            const libelleTaille = $(
                'option:selected',
                event.currentTarget
            ).data(J_LIBELLE_DATA)
            const tailleFiltre = $('option:selected', event.currentTarget).val()
            const rm = $(J_REFERENCE_MODEL).val()
            const cc = $(J_CODE_COULEUR).val()

            ajaxLoader.loadAndExecuteCallBack(
                'POST',
                {
                    libelleTaille: libelleTaille,
                    tailleFiltre: tailleFiltre,
                    rm: rm,
                    cc: cc
                },
                function (content) {
                    $(J_PRODUIT_ALERTE_CONTENT_DESTINATION)
                        .empty()
                        .append(content)
                    $(J_PRODUIT_ALERT_POPUP).modal({
                        // On fait apparaître la modal
                        keyboard: true,
                        show: true
                    })
                    cleanTextOnFocus.setEvent()
                    manageValidationForProductAlert()
                },
                function (content) {
                    const $location = $(J_PRODUIT_ALERTE_CONTENT_DESTINATION)
                    $location.empty().append($t('AJAXLOADERINTERNALERROR'))
                    $(J_PRODUIT_ALERT_POPUP).modal({
                        keyboard: true,
                        show: true
                    })
                },
                action
            )
        }
    })
}

/*
 * Set l'event le bouton mobile créer alerte
 * la popup d'alerte s'affichera si le client ne trouve pas sa taille.
 */
function setEventProduitMob() {
    $(J_SHOW_ALERTE_CONFIRMATION_MOB).on('click', function () {
        const action = $(J_SHOW_ALERTE_CONFIRMATION_MOB).data('action')
        const libelleTaille = ''
        const tailleFiltre = ''
        const rm = $(J_REFERENCE_MODEL).val()
        const cc = $(J_CODE_COULEUR).val()
        ajaxLoader.loadAndExecuteCallBack(
            'POST',
            {
                libelleTaille: libelleTaille,
                tailleFiltre: tailleFiltre,
                rm: rm,
                cc: cc
            },
            function (content) {
                $(J_PRODUIT_ALERTE_CONTENT_DESTINATION).empty().append(content)
                $(J_PRODUIT_ALERT_POPUP).modal({
                    // On fait apparaître la modal
                    keyboard: true,
                    show: true
                })
                cleanTextOnFocus.setEvent()
                manageValidationForProductAlert()
            },
            function (content) {
                const $location = $(J_PRODUIT_ALERTE_CONTENT_DESTINATION)
                $location.empty().append($t('AJAXLOADERINTERNALERROR'))
                $(J_PRODUIT_ALERT_POPUP).modal({
                    keyboard: true,
                    show: true
                })
            },
            action
        )
    })
}
/*
 * Set l'event sur le module alerte en bas du listing des produits de la page catalogue
 */
function setEventProduitNoSize() {
    const action = $(J_SHOW_ALERTE_CONFIRMATION).data('action') // On récupère le controller visé

    $(J_SHOW_ALERTE_CONFIRMATION).on('click', function () {
        let params = {}
        const email = $(J_EMAIL).val()

        const rm = $(J_REFERENCE_MODEL).val()
        const cc = $(J_CODE_COULEUR).val()

        // On récupère l'email et vérifie s'il est valide. sinon on met l'erreur dans l'input
        if (!validationForm.isValideEmail(email)) {
            $(J_EMAIL)[0].value = $('INVALIDEMAIL')
            return
        } else {
            params = {
                emailAlert: email,
                rm: rm,
                cc: cc
            }
        }
        ajaxLoader.loadAndExecuteCallBack(
            'POST',
            params,
            function (content) {
                if (content.indexOf('window.location.href') == -1) {
                    $(J_CATALOGUE_ALERT_CONTENT_DESTINATION)
                        .empty()
                        .append(content)
                    $(J_CATALOGUE_ALERT_POPUP).modal({
                        keyboard: true,
                        show: true
                    })
                }
            },
            function (content) {
                const $location = $(J_CATALOGUE_ALERT_CONTENT_DESTINATION)
                $location.empty().append($t('AJAXLOADERINTERNALERROR'))
                $(J_CATALOGUE_ALERT_POPUP).modal({
                    keyboard: true,
                    show: true
                })
            },
            action
        )
    })
}

/*
 * Gestion de la validation de l'alerte de la page produit
 */
function manageValidationForProductAlert() {
    $(J_SUBMIT_ALERT_BUTTON).on('click', function () {
        const arrayParams = $(J_FORM).serializeArray()
        const params = {}
        const action = $(J_FORM).attr('action')

        if (action !== undefined) {
            $.each(arrayParams, function () {
                params[this.name] = this.value
            })

            if (params.emailAlert !== undefined) {
                if (!validationForm.isValideEmail(params.emailAlert)) {
                    $(J_EMAIL_PRODUCT)[0].value = $('INVALIDEMAIL')
                    return
                }
            }

            ajaxLoader.loadAndExecuteCallBack(
                'POST',
                params,
                function (content) {
                    $(J_RESULT_LOCATION).empty().append(content)
                },
                function (jqXHR, textStatus) {
                    const $location = $(J_RESULT_LOCATION)
                    $location.empty().append($t('AJAXLOADERINTERNALERROR'))
                },
                action
            )
        }
    })
}

export default {
    setEventCatalogue: setEventCatalogue,
    setEventProduit: setEventProduit,
    setEventProduitMob: setEventProduitMob,
    setEventProduitNoSize: setEventProduitNoSize
}
